import $ from 'jquery'

export default {
	init() {
		const $wrapper = $("#regija-restavracije")
		const $regija = $wrapper.find(".regija")
		if (!$regija.length) return // no regija element found

		const $postsWrapper = $wrapper.find(".regija-posts")
		const pokrajina = $regija.data('regija')
		const language = document.documentElement.lang === "en-US" ? "en" : "si"

		$.ajax({
			url: '/wp-json/vivi/v1/restavracije',
			method: 'POST',
			beforeSend: function (xhr) {
				if (window.my_ajax_object && my_ajax_object.rest_nonce) {
					xhr.setRequestHeader("X-WP-Nonce", my_ajax_object.rest_nonce)
				}
			},
			data: {
				pokrajina: pokrajina,
				language: language,
				load_all: 1,
				load_sponsors: 0,
			},
			success: function (response) {
				if (!response) {
					return
				}

				$postsWrapper.html(response.content)
				$wrapper.find(".regija-count").text("(" + response.total_posts_count + ")")
			},
			error: function (xhr, status) {
				console.error("Regional restaurants could not be loaded.", status)
			},
		})
	}
}
